import { steps, type RequestRecord } from './model';

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString('pt-BR');
}

export async function downloadRequestExcel(record: RequestRecord) {
  const XLSX = await import('xlsx');
  const headers: string[] = ['Protocolo', 'Tipo', 'Status', 'Responsável', 'Divisão', 'Criado em', 'Atualizado em'];
  const row: (string | number)[] = [
    record.protocol,
    record.kind === 'projeto' ? 'Projeto de Desenvolvimento' : 'Amostra',
    record.status,
    record.owner,
    record.division,
    formatDate(record.createdAt),
    formatDate(record.updatedAt),
  ];

  for (const step of steps[record.kind]) {
    for (const field of step.fields) {
      headers.push(field.label);
      row.push(record.data[field.key] ?? '');
    }
  }

  const sheet = XLSX.utils.aoa_to_sheet([headers, row]);
  sheet['!cols'] = headers.map((header) => ({ wch: Math.min(Math.max(header.length, 12), 40) }));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, record.kind === 'projeto' ? 'Projeto' : 'Amostra');
  XLSX.writeFile(workbook, `${record.protocol}.xlsx`);
}
